import { agendaRepo } from "@/repositories/agendaRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";
import { map } from "rxjs";
import type { TeamIdOrOrg } from "./common";

export const useGetAgenda = (tenantId: string, agendaId: string) => {
  return useObservable(
    () => agendaRepo.get(tenantId, agendaId),
    [tenantId, agendaId]
  );
};

export const useAgendaList = (tenantId: string, teamId: TeamIdOrOrg) => {
  return useObservable(
    () =>
      agendaRepo
        .list(tenantId)
        .pipe(
          map((list) =>
            list.filter(
              (item) =>
                !item.template && (teamId == "org" || item.teamId === teamId)
            )
          )
        ),
    [tenantId, teamId]
  );
};

export const useAgendaTemplateList = (
  tenantId: string,
  teamId: TeamIdOrOrg
) => {
  return useObservable(
    () =>
      agendaRepo
        .list(tenantId)
        .pipe(
          map((list) =>
            list.filter(
              (item) =>
                item.template && (teamId == "org" || item.teamId === teamId)
            )
          )
        ),
    [tenantId, teamId]
  );
};
